import i18n from '@/i18n';

const t = (key) => i18n.global.t(key);

// Integrations of a LINK handled by the site, listed when the LINK holds the matching license
const TYPES = {
    AJAX: { label: 'integration.ajax', path: '/component-edit-ajax', icon: 'mdi mdi-security text-danger' },
    SPC: { label: 'integration.spc', path: '/component-edit-spc', icon: 'mdi mdi-security text-danger' },
    SmartIntego: { label: 'integration.smartIntego', path: '/component-edit-smart-intego', icon: 'mdi mdi-door-closed-lock' },
    UZ: { label: 'integration.uz', path: '/component-edit-uz', icon: 'mdi mdi-door-closed-lock' },
    Aperio: { label: 'integration.aperio', path: '/component-edit-aperio', icon: 'mdi mdi-door-closed-lock' },
    Video: { label: 'integration.video', path: '/component-edit-video', icon: 'mdi mdi-video-outline' },
};

export default class Integration {
    type;       // "AJAX", "SPC", "SmartIntego", "UZ", "Aperio" or "Video"
    hubId;
    state;      // null until the LINK reports it

    constructor(type, hubId, state = null) {
        this.type = type;
        this.hubId = hubId;
        this.state = state;
    }

    get label() {
        return t(TYPES[this.type].label);
    }

    // Icon of the components tree node
    get jstreeData() {
        return JSON.stringify({ icon: TYPES[this.type].icon });
    }

    get has_state() {
        return this.state != null;
    }

    get isActive() {
        return this.state === true;
    }

    get key() {
        return `${this.hubId}_${this.type}`;
    }

    path(facilityId) {
        return { path: TYPES[this.type].path, params: { facilityId: facilityId, hubId: this.hubId } };
    }
}
